import React from 'react';
import {Route} from "react-router";
import {compArr} from "../selectors";
import {compose} from "redux";
import {connect} from "react-redux";
import {PathBreadcrumbItem, withBreadcrumbCurried} from "../../Boilerplate/BreadcrumbContext";
import {withLoading404} from "../../Boilerplate/deferLoaderHoc";
import {setViewPath} from "../../../actions/view";
import {getDailyLog} from "../../../actions/dailyLog";
import DailyLogDetail from "./DailyLogDetail";
import DailyLogEdit from "./DailyLogEdit";

class DailyLog extends React.PureComponent {
  render() {
    return (
      <div>
        <Route exact path="/projects/:id/daily-logs/:dailyLogId" component={DailyLogDetail}/>
        <Route path="/projects/:id/daily-logs/:dailyLogId/edit" component={DailyLogEdit}/>
      </div>
    );
  }
}

const DailyLogBreadcrumb = props => PathBreadcrumbItem({ path: `/projects/${props.match.params.id}/daily-logs/`, resource: props.dailylog.resource });

export default compose(
  connect(
    (state, props) => {
      const projectId = props.match.params.id;
      const dailylog = state.view.subview.data[props.match.params.dailyLogId];
      const loading = state.view.subview.cache.loading;
      const path = state.view.path;
      const itempath = ['projects', props.match.params.id, 'dailylogs', props.match.params.dailyLogId];
      if (!compArr(path, itempath) || loading || !dailylog) return { loading: true };
      return { dailylog, projectId };
    },
    (dispatch, props) => ({
      preload: () => dispatch(setViewPath(['projects', props.match.params.id, 'dailylogs', props.match.params.dailyLogId])),
      loader: () => dispatch(getDailyLog(props.match.params.id, props.match.params.dailyLogId)),
    })),
  withLoading404,
  withBreadcrumbCurried(DailyLogBreadcrumb),
)(DailyLog);



// WEBPACK FOOTER //
// ./src/components/Projects/DailyLogs/DailyLog.js